{
    "Id": "ID :",
    "IdPlaceholder": "[Auto Assigned]",
    "NamePlaceholder": "Environnement de gestion centrale",
    "BillingId": "ID de facturation :",
    "ParentCme": "Parent CME :",
    "DescriptionIsRequired": "La description est requise.",
    "CMEDetails_ButtonHelpLabel": "De l'aide ?",
    "CMEDetails_ButtonSubmitLabel": "OK",
    "CMEDetails_ButtonCancelLabel": "Annuler",
    "CMEDetails_PromptMessage": "Êtes-vous sûr de vouloir fermer cette fenêtre ? Toutes les configurations modifiées seront perdues lors de la fermeture.",
    "CMEDetails_PromptConfirm": "Oui",
    "CMEDetails_PromptCancel": "Annuler",
    "CMEDetails_Description": "Description :",
    "NAME": "CMEDetails",
    "CMEDetails_ProviderIDS": "ID du fournisseur SSO :",
    "CMEDetails_ProviderIDS_Help": "Laissez ce champ vide sauf si vous configurez le Single-Sign On (SSO). Votre identifiant fournisseur vous aura été fourni si vous utilisez le SSO.",
    "CMEDetails_ProviderIDS_Validation_NoMoreThan5": "Le nombre d'identifiants de fournisseurs SSO est limité à 5.",
    "CMEDetails_ProviderIDS_Validation_IDsInvalid": "Veillez à ce que les identifiants des fournisseurs soient uniquement des lettres, des chiffres, des traits d'union ou des traits de soulignement, qu'ils ne comportent pas plus de 15 caractères et qu'ils figurent dans une liste séparée par des virgules.",
    "CMEDetails_Disable_Akixi_Login": "Désactiver la capacité de connexion par nom d'utilisateur :"
}